export default {
  apiKey: 'AIzaSyAaj4wXT1GvQNYdASdeZvEcoBKnW_redFQ',
  authDomain: 'grapevine-dc853.firebaseapp.com',
  databaseURL: 'https://grapevine-dc853.firebaseio.com',
  projectId: 'grapevine-dc853',
  storageBucket: 'grapevine-dc853.appspot.com',
  messagingSenderId: '481965489765'
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js